import { api } from "../App";
import { buildTree, buildHierarchy } from "../utils/disciplineStructure";
import { SET_DISCIPLINE_STRUCTURE_DATA, SET_DISCIPLINE_STRUCTURE_FILTER_CID, SET_DISCIPLINE_STRUCTURE_FILTER_MID, SET_DISCIPLINE_STRUCTURE_FILTER_TRP, SET_DISCIPLINE_STRUCTURE_FILTER, SET_DISCIPLINE_STRUCTURE_LOADING } from "./types";
import { createNotification } from "../components/Notifications/Notifications";

const COURSE_TYPE_ENDPOINTS = {
  '0': 'discipline_structure_ba',
  '1': 'discipline_structure_do',
  '2': 'discipline_structure_vd',
};

const getDisciplineStructureEndpoint = (course_type) =>
  COURSE_TYPE_ENDPOINTS[String(course_type)] || COURSE_TYPE_ENDPOINTS['0'];

export const getSchoolYears = () => async (dispatch, getState) => {
  try {
    const { data } = await api.get('/course_structure/school_year')
    const payload = { schoolYears: data }
    dispatch({ type: SET_DISCIPLINE_STRUCTURE_FILTER, payload });

  } catch (ERR) {
    console.log(ERR)
  } finally {
  }
};

export const getPeoples = (yearId, params) => async (dispatch, getState) => {
  try {
    const { data } = await api.get(`/course_structure/people/${yearId}`, { params })
    const payload = { peoples: data }
    dispatch({ type: SET_DISCIPLINE_STRUCTURE_FILTER, payload });

  } catch (ERR) {
    console.log(ERR)
  } finally {
  }
};

export const getCourses = (yearId, peopleId, params) => async (dispatch, getState) => {
  try {
    const { data } = await api.get(`/course_structure/courses/${yearId}/${peopleId}`, { params })
    const payload = { courses: data }
    dispatch({ type: SET_DISCIPLINE_STRUCTURE_FILTER, payload });

  } catch (ERR) {
    console.log(ERR)
  } finally {
  }
};

export const getProfiles = () => async (dispatch, getState) => {
  try {
    const { data } = await api.get(`/track_profile`)
    const payload = { profiles: data }
    dispatch({ type: SET_DISCIPLINE_STRUCTURE_FILTER, payload });

  } catch (ERR) {
    console.log(ERR)
  } finally {
  }
};

export const getData = (year, people, course, profile, params) => async (dispatch, getState) => {
  console.log('params::: ', params);
  try {
    dispatch({ type: SET_DISCIPLINE_STRUCTURE_LOADING, payload: true });
    const { data } = await api.get(`/course_structure/${year}/${people}/${course}/${profile}`, { params })
    dispatch({ type: SET_DISCIPLINE_STRUCTURE_DATA, payload: buildTree(data) });

  } catch (ERR) {
    console.log(ERR)
  } finally {
    dispatch({ type: SET_DISCIPLINE_STRUCTURE_LOADING, payload: false });
  }
};
////// <----------  НОВАЯ СТРУКТУРА ----------> 06/12 159 ////////////////
export const getDataStructure = ({ course_type, ...params }) => async (dispatch, getState) => {
  try {
    const endpoint = getDisciplineStructureEndpoint(course_type);
    const urlParams = new URLSearchParams(params).toString();

    dispatch({ type: SET_DISCIPLINE_STRUCTURE_LOADING, payload: true });
    const { data } = await api.get(`/${endpoint}?${urlParams}`)

    // TODO  оптимизировать? фильтры на одном запросе  с испл-м разных ГЕТ параметров
    if (!data || data.length === 0) {
      dispatch({ type: SET_DISCIPLINE_STRUCTURE_DATA, payload: [] });
      return;
    }
    if (!!data[0].predmet) dispatch({ type: SET_DISCIPLINE_STRUCTURE_DATA, payload: buildHierarchy(data) });
    if (!!data[0].oid) return dispatch({ type: SET_DISCIPLINE_STRUCTURE_FILTER_TRP, payload: data });
    if (!!data[0].cid) dispatch({ type: SET_DISCIPLINE_STRUCTURE_FILTER_CID, payload: data });
    if (!!data[0].teacher_mid) {
      dispatch({ type: SET_DISCIPLINE_STRUCTURE_FILTER_MID, payload: data });
      dispatch({ type: SET_DISCIPLINE_STRUCTURE_FILTER_TRP, payload: [] });
      dispatch({ type: SET_DISCIPLINE_STRUCTURE_FILTER_CID, payload: [] });
    }
  } catch (ERR) {
    console.log(ERR)
  } finally {
    dispatch({ type: SET_DISCIPLINE_STRUCTURE_LOADING, payload: false });
  }
};
export const getDataStructureDO = ({ course_type, ...params }) => async (dispatch, getState) => {
  try {
    const endpoint = getDisciplineStructureEndpoint(course_type);
    const urlParams = new URLSearchParams({ ...params, trp_id: 0 }).toString();

    dispatch({ type: SET_DISCIPLINE_STRUCTURE_LOADING, payload: true });
    const { data } = await api.get(`/${endpoint}?${urlParams}`)

    // Обрабатываем данные так же, как в getDataStructure
    if (data.length !== 0 && data !== undefined && data !== null) {
      if (!!data[0]?.predmet) {
        dispatch({ type: SET_DISCIPLINE_STRUCTURE_DATA, payload: buildHierarchy(data) });
      } else if (!!data[0]?.cid) {
        dispatch({ type: SET_DISCIPLINE_STRUCTURE_FILTER_CID, payload: data });
      }
    }
  } catch (ERR) {
    console.log(ERR)
  } finally {
    dispatch({ type: SET_DISCIPLINE_STRUCTURE_LOADING, payload: false });
  }
};

export const updateData = (params, data) => async (dispatch, getState) => {
  try {
    const { course_type, xp_key, mid, cid, trp_id } = params
    const endpoint = getDisciplineStructureEndpoint(course_type);

    // dispatch({ type: SET_DISCIPLINE_STRUCTURE_LOADING, payload: true });
    // trp_id остаётся захардкоженным 0 — существующее поведение, не в рамках этой задачи
    await api.put(`/${endpoint}/${xp_key}/${mid}/${cid}/${0}`, data)
    createNotification('success', 'Данные успешно сохранены', 'Сохранено', 3000)
    // dispatch({ type: SET_DISCIPLINE_STRUCTURE_DATA, payload: buildTree(data) });

  } catch (ERR) {
    console.log(ERR)
    createNotification('error', 'Не удалось сохранить данные', 'Ошибка', 3000)
  } finally {
    // dispatch({ type: SET_DISCIPLINE_STRUCTURE_LOADING, payload: false });
  }
};